import { useNavigate } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";

import { AccessibleIcon } from "@/components/accessible-icon";
import { Button } from "@/components/button";
import { Loader } from "@/components/Loader";

import { usePublishedPost } from "../../../hooks/usePublishedPost";
import { InteractionsComparison } from "./InteractionsComparison";
import { PostPerformance } from "./PostPerformance";
import { PostSummaryCard } from "./PostSummaryCard";

export function PostInsightsPage({ postId }: { postId: number }) {
  const navigate = useNavigate();
  const { data, isError, isLoading } = usePublishedPost(postId);

  return (
    <div className="flex flex-col gap-2xl p-xl">
      <Button
        className="self-start"
        color="gray"
        onPress={() =>
          navigate({
            search: { tab: "insights", view: "posts" },
            to: "/publish",
          })
        }
        variant="secondary"
      >
        <AccessibleIcon>
          <ChevronLeft />
        </AccessibleIcon>
        Back to insights
      </Button>

      {isLoading && <Loader className="py-20" />}
      {isError && (
        <p className="p-3xl text-center text-sm text-text-tertiary">
          We couldn&apos;t find this post. It may have been removed or not
          published yet.
        </p>
      )}
      {data && (
        <div className="grid items-start gap-2xl lg:grid-cols-[380px_1fr]">
          <PostSummaryCard post={data.post} />
          <div className="flex min-w-0 flex-col gap-2xl">
            <PostPerformance
              averagePostCount={data.averagePostCount}
              averages={data.averages}
              post={data.post}
            />
            <InteractionsComparison
              averages={data.averages}
              insights={data.post.insights}
            />
          </div>
        </div>
      )}
    </div>
  );
}
